export class FetchElectricMeterManufacturersAction {
  static readonly type = '[Electric Meter] Fetch Electric Meter Manufacturers';
}
